// extracted by mini-css-extract-plugin
export default {"container":"hom_B9WaQ","blocks":"hom_blo_10U6Z"};